import View from "../account/views/PreferencesPageView";
import components from "./components.js";
components.define("js-preferences-page", View);